import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import {
  addVehicleToBulkActionsList,
  assignVehicleTransport,
  completeVehicleTransport,
  removeVehicleFromBulkActionsList,
} from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { HBox, VBox } from '../../../../components/Box';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { swapKeyValues } from '../../../../utils/object';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { REQUEST_ADDRESSES_BY_IDS } from '../../../Address/constants';
import { selectAddress } from '../../../Address/selectors';
import { selectVehicleBulkActionsList } from '../../../Vehicles/selectors';
import { Checkbox } from '../../../../components/Checkbox';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};
const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 150px;
    max-width: 150px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }
  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  NONE: '0',
  Breedijk_transport: '1',
  Alwin_ter_Schure: '2',
  John_van_de_Berg: '3',
  Matthijs_Nijkamp: '4',
  Dirk: '5',
  Harry_Nijboer: '6',
  Overig_intern: '7',
  Wachten_op_transport: '8',
};

export const TransportAssignableSortMap = swapKeyValues(TransportAssignable);
export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class IDWE_transport_nl_individualComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get action() {
    return this.props.action;
  }

  get bulkActionsList() {
    let list = [];
    if (this.props.bulkActionsList?.length) {
      list = this.props.bulkActionsList;
    }
    return list;
  }

  isSelectedVehicle() {
    return this.bulkActionsList?.filter(item => item?.id == this.vehicle?.id)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();
    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, this.action.functionName);
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    const vehicle = this.vehicle;
    if (this.props.work) return null;
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_1_nl_in.modal.individual_transport_plan')}
      >
        <HBox flexWrap center>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <row>
              <VBox vCenter>
                <VBox className="regplate col-regplate-vin">
                  <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                  <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
                </VBox>
                <VBox className="col-model-info">
                  <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                  <p>{vehicle.model_name}</p>
                </VBox>
                <VBox className="address col-address-from">
                  <CompanyLabelById
                    fetchName
                    transportCard
                    transport_to={vehicle?.transport_individual_from_company_name}
                    company_id={vehicle?.transport_individual_from_company_id}
                  />
                  <CompanyLabelById
                    fetchName
                    transportCard
                    transport_to={vehicle?.transport_individual_from_company_name}
                    company_id={vehicle?.transport_individual_from_company_id}
                  />

                  {vehicle.transport_individual_from_address_id == 'zwolle' ? (
                    'Kleefstraat Zwolle'
                  ) : (
                    <AddressFields inlineshort addressId={vehicle.transport_individual_from_address_id} />
                  )}
                  <div className="mb-1">
                    <CompanyLabelById fetchPhone company_id={vehicle.transport_individual_from_company_id} />
                  </div>
                </VBox>
                <VBox className="address col-address-to"></VBox>
                <VehicleStatusLabel>in</VehicleStatusLabel>
              </VBox>
            </row>
          </div>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <br />

            {TransportAssignableOptions.map(a => (
              <Button
                primary={a.value == this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label.replace(/\_/g, ' ')}
              </Button>
            ))}
          </div>
        </HBox>
        <ModalControls>
          {this.props.work || this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <Button
                primary
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </Button>
              <Button alert onClick={() => this.props.done(this.reset.bind(this))}>
                {this.lbl('Complete')}
              </Button>

              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <Checkbox checked={this.isSelectedVehicle()} onChange={e => this.onSelectVehicle(e, vehicle)} />
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle?.vin?.slice(-6) || ''}</span>
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>
            <VBox left className="address col-address-from">
              {vehicle?.transport_individual_from_company_id == '4' && 'in de Wal'}
              {this.props.fromCompanyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_individual_from_company_name}
                  company_id={vehicle?.transport_individual_from_company_id}
                />
              )}
              {this.props.fromAddress && (
                <AddressFields inlineshort addressId={vehicle.transport_individual_from_address_id} />
              )}
              <div className="mb-1">
                <CompanyLabelById fetchPhone company_id={vehicle.transport_individual_from_company_id} />
              </div>
            </VBox>
            <VBox left className="address col-address-to">
              {vehicle?.transport_individual_to_company_id == '4' && 'in de Wal'}
              {this.props.toCompanyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_individual_to_company_name}
                  company_id={vehicle.transport_individual_to_company_id}
                />
              )}
              {this.props.toAddress && <AddressFields inlineshort addressId={vehicle.transport_individual_to_address_id} />}
            </VBox>
            {/* {vehicle.transport_individual_requested === '1' ? <VehicleStatusLabel>Los transport</VehicleStatusLabel> : <VehicleStatusLabel>in</VehicleStatusLabel>}
            <Label count={vehicle?.transportindividual} ranges={ranges}>
            {vehicle?.transportindividual || '0'}
          </Label> */}
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

IDWE_transport_nl_individualComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
      REQUEST_ADDRESSES_BY_IDS,
    ]),
    fromCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_individual_from_company_id, 'name'),
    toCompanyName: selectCompanyProperty(ownProps.cell.vehicle.transport_individual_to_company_id, 'name'),
    fromAddress: selectAddress(ownProps.cell.vehicle.transport_individual_from_address_id),
    toAddress: selectAddress(ownProps.cell.vehicle.transport_individual_to_address_id),
    bulkActionsList: selectVehicleBulkActionsList(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    assign(id, callback) {
      dispatch(
        assignVehicleTransport(ownProps.cell.vehicle.id, `${id}`, false, true, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    done(callback) {
      let id = ownProps.cell.vehicle.id;
      const action_name = ownProps.action.functionName;
      dispatch(
        completeVehicleTransport(id, false, true, action_name, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
    addVehicleToBulkActionsList(vehicle, kanbanTaskName) {
      dispatch(addVehicleToBulkActionsList(vehicle, [], kanbanTaskName));
    },
    removeVehicleFromBulkActionsList(vehicleId) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_transport_nl_individual = compose(withConnect, withRouter)(IDWE_transport_nl_individualComp);
